import { render, staticRenderFns } from "./WithdrawHistory.vue?vue&type=template&id=2ba939a9&scoped=true"
import script from "./WithdrawHistory.vue?vue&type=script&lang=js"
export * from "./WithdrawHistory.vue?vue&type=script&lang=js"
import style0 from "./WithdrawHistory.vue?vue&type=style&index=0&id=2ba939a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba939a9",
  null
  
)

export default component.exports